<template>
  <b-sidebar
    id="sidebar-create-scientific-topics"
    sidebar-class="sidebar-lg"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ topic.id ? $t('Update') : $t('Create') }}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="clear(hide)"
        />
      </div>

      <validation-observer ref="topicForm">
        <!-- Body -->
        <b-form
          class="p-2"
          @submit.prevent
        >
          <!-- Uz Name -->
          <b-form-group
            :label="$t('name')"
            label-for="uz-name"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('name')"
              rules="required"
            >
              <b-form-input
                id="uz-name"
                v-model="topic.name"
                trim
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <!-- Region -->
          <b-form-group
            :label="$t('Region')"
            label-for="region"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('Region')"
              rules="required"
            >
              <v-select
                id="region"
                v-model="topic.region"
                :reduce="(option) => option.id"
                :options="regions"
                :get-option-label="(option) => $langName(option.name)"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
              @click="submit(hide)"
            >
              {{ topic.id ? $t('Update') : $t('Create') }}
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="outline-secondary"
              @click="clear(hide)"
            >
              {{ $t('Cancel') }}
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required } from '@/libs/validations/validations'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    vSelect,
    ValidationObserver,
    ValidationProvider,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    topic: {
      get() {
        return this.$store.state.scientificTopics.topic
      },
      set(data) {
        this.$store.commit('topic/UPDATE', data)
      },
    },
    regions() {
      return this.$store.state.staticModule.regions
    },
  },
  created() {
    this.$store.dispatch('staticModule/regions')
  },
  mounted() {
    localize(this.$i18n.locale)
  },
  methods: {
    clear(hide) {
      this.$store.commit('scientificTopics/FRESH')
      hide()
    },
    submit(hide) {
      this.$refs.topicForm.validate().then(success => {
        if (success) {
          this.$createSwal(this, this.topic, `scientificTopics/${this.topic.id ? 'update' : 'create'}`, () => {
            this.$emit('refetchData')
            this.$store.commit('scientificTopics/FRESH')
          })
          hide()
        }
      })
    },
  },
}
</script>
